export const getElementsByTagName = (param: string) => [''];
export const createElement = (param: string) => [''];
